export default __webpack_public_path__ + "static/media/52t.1d15b771.jpg";